export default "/assets/f57a62e9efddf6ace18b15572f81905b.woff2";